export const SN_AIA_USECASE = 'sn_aia_usecase'
export const SN_AIA_TEAM_MEMBER = 'sn_aia_team_member'
export const SN_AIA_TEAM = 'sn_aia_team'
export const SN_AIA_VERSION = 'sn_aia_version'
export const SN_AIA_USECASE_CONFIG = 'sn_aia_usecase_config_override'
export const SN_AIA_TRIGGER_CONFIG = 'sn_aia_trigger_configuration'
export const SN_AIA_TRIGGER_MAPPING = 'sn_aia_trigger_agent_usecase_m2m'
export const SYS_AGENT_ACCESS_ROLE_CONFIG = 'sys_agent_access_role_configuration'
export const SYS_AGENT_ACCESS_ROLE_MAPPING = 'sys_agent_access_role_mapping'
export const SYS_USER_ROLE = 'sys_user_role'
export const SYS_SECURITY_ACL = 'sys_security_acl'
export const SYS_SECURITY_ACL_ROLE = 'sys_security_acl_role'

export const GEN_AI_AGENTIC_USECASE_TYPE = 'd9eb25b39fc222109570e67e8a0a1c6a'

/**
 * Security attribute sys_id for "user is authenticated" ACL condition
 */
export const USER_IS_AUTHENTICATED = '239bdf0c47d23110ba46ff58936d4330'

/**
 * Role sys_id assigned to sys_security_acl_role when securityAcl.type is 'Public'
 */
export const PUBLIC_ACCESS_ROLE_SYS_ID = 'b0593b350a0a0aa7001d689e4542dc28'

/** Default ACL field values for generated sys_security_acl records */
export const ACL_DEFAULTS = {
    operation: 'execute',
    active: true,
    adminOverrides: true,
    advanced: false,
    decisionType: 'allow',
    localOrExisting: 'Existing',
} as const

export const OOB_CHANNEL_MAP = {
    'Now Assist Panel': 'b023fcb3537321106167ddeeff7b12a8',
} as const
